import axios from 'axios';
import sm4 from 'sm-crypto/dist/sm4';

const {
    javaUrl,
} = require('../package.json');

const JAVA_SM4_KEY = '47866fcfbb9f808952321a004a9b0654';
const JAVA_SM4_IV = 'e8510547a4ecf355d05fb98e46a75322';

/**
 * hex 字符串转 base64
 */
function hexToBase64(hex) {
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < hex.length; i += 2) {
        bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
    }
    let binary = '';
    bytes.forEach((b) => {
        binary += String.fromCharCode(b);
    });
    return btoa(binary);
}

/**
 * SM4 加密密码
 */
function encryptPassword(password) {
    const encryptedHex = sm4.encrypt(password, JAVA_SM4_KEY, {
        mode: 'cbc',
        iv: JAVA_SM4_IV,
    });
    return hexToBase64(encryptedHex);
}

/**
 * 调用 Java 登录接口获取 token
 */
export function login(username = 'admin', password = 'shouwang@2026') {
    const encryptedPassword = encryptPassword(password);
    return axios.post(`${javaUrl}/login`, {
        username,
        password: encryptedPassword,
    }, {
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
        },
        timeout: 10000,
    }).then((res) => {
        if (res.data && res.data.code === 200 && res.data.token) {
            localStorage.setItem('java_token', res.data.token);
            return res.data.token;
        }
        return Promise.reject(res.data.msg || 'Java 登录失败');
    });
}

/**
 * 清除 Java token
 */
export function logout() {
    localStorage.removeItem('java_token');
}

/**
 * 获取 Java token
 */
export function getToken() {
    return localStorage.getItem('java_token');
}

/**
 * 设置 Java token
 */
export function setToken(token) {
    localStorage.setItem('java_token', token);
}